import ProjectCurrency from "../ProjectCurrency";

describe("ProjectCurrency Model", () => {
  test("belongsTo relations", () => {
    expect(
      ProjectCurrency.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
